import Dialog from "../../atoms/dialog";
import ExportBlueprintFiles from "../blueprint/ExportBlueprintFiles";

const ExportBlueprintFilesAlert = (props) => {

    const { onClose, setOpenExportBlueprintAlert } = props;

    const handleClose = () => {
        onClose()
    }

    return (
        <Dialog
            open={true}
            handleClose={handleClose}
            paperProps={{ id: "deleteTestcaseAlert" }}
            title={"Export Blueprint Files"}

        >
            <ExportBlueprintFiles onClose={onClose} setOpenExportBlueprintAlert={setOpenExportBlueprintAlert} />
        </Dialog >
    )
}

export default ExportBlueprintFilesAlert;